function inProgress(requests: { kvsName: string, progress: number, error: boolean }[], request?: { kvsName: string }): boolean {
  const target = requests.find(el => el.kvsName === request?.kvsName && el.progress !== 100 && el.error === false);
  return target !== undefined;
}

export default inProgress;
